module.exports = __webpack_public_path__ + "img/app-logo.ca4a6e83.svg";